module.exports = __webpack_public_path__ + "img/aeon.edf647cb.svg";